export default {
        url:
            "https://api.maptiler.com/maps/openstreetmap/256/{z}/{x}/{y}.jpg?key=Vpb9gLs3RLUVbJNWIZqT",
        attribution:
            '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
};
